// frontend/src/components/pantallaInformativa/ColaRotativa.js
import React, { useState } from 'react';
import ColaEspera from './ColaEspera';

/**
 * El lugar del TV que comparten ANSES, Cobros y Tribunales: muestra una cola por vez y, cuando
 * terminó de pasar todas sus páginas, sigue con la próxima. Recibe solo las colas que tienen gente
 * (la vacía no se muestra); con una sola, se queda quieta y pagina como cualquier cola.
 *
 * Se recuerda la clave de la cola que se está mostrando y no su posición: si otra cola se vacía o
 * aparece en una actualización, la que está en pantalla sigue. Si la que se mostraba se vació, se
 * pasa a la primera.
 *
 * @param grupos [{ clave, titulo, icono, turnos }] en el orden en que se alternan.
 */
function ColaRotativa({ grupos }) {
    const [claveActual, setClaveActual] = useState(null);

    if (grupos.length === 0) return null;

    const indiceGuardado = grupos.findIndex((grupo) => grupo.clave === claveActual);
    const indice = indiceGuardado === -1 ? 0 : indiceGuardado;
    const actual = grupos[indice];
    // ColaEspera guarda el callback en un ref: que sea una función nueva en cada render no reinicia nada.
    const siguiente = () => setClaveActual(grupos[(indice + 1) % grupos.length].clave);

    return (
        <ColaEspera
            // Otra cola es otra lista: se vuelve a medir y arranca en su primera página.
            key={actual.clave}
            titulo={actual.titulo}
            icono={actual.icono}
            turnos={actual.turnos}
            alCompletarRonda={grupos.length > 1 ? siguiente : undefined}
        />
    );
}

export default ColaRotativa;
